export default __webpack_public_path__ + "static/media/single-project-page-03-img11.6117792c.jpg";